import React from 'react';
import { useParams } from 'react-router-dom';

import PrepagoPage from '../../../manager/financial/prepago';

interface ParamTypes {
  id: string
}

const page = () => {
  const { id } = useParams<ParamTypes>();

  return <PrepagoPage subsidiaryId={id} canApprove={false} />;
};

export default page;
